<template>
  <div class="mt-6">
    <LoadingSpinner class="h-10 w-10 text-yellow-500/80 my-8" />
    <h6
      class="my-8 text-gray-600 text-center mt-6"
      v-if="seriesLine.length === 0 && !$loading.value"
    >
      بدون داده
    </h6>
    <apexchart
      v-for="(serie, index) in seriesLine"
      :key="serie"
      class="flex content-center w-full drop-shadow-lg rounded-md"
      type="line"
      height="220"
      :options="chartOptionsLine[index]"
      :series="serie"
      @dataPointSelection="clickHandler"
    />
  </div>
</template>
<script>
import apexchart from "vue3-apexcharts";
import { chartReport } from "@/API/API";
import LoadingSpinner from "./General/LoadingSpinner.vue";
//import jDate from "jalali-date";

export default {
  name: "ReportChart",
  components: { apexchart, LoadingSpinner },
  props: ["Category", "Line", "Product", "year", "month", "day"],
  data() {
    return {
      seriesLine: [],
      getchart: {},
      chartOptionsLine: [],
      option: {
        tooltip: {
          intersect: true,
          shared: false,
        },
        markers: {
          size: 6,
        },
        colors: ["#D4526E", "#545454"],
        dataLabels: {
          enabled: true,
          enabledOnSeries: undefined,
          formatter: function (val) {
            if (val < 0 && val > -10) {
              val = Math.abs(val) + " -";
            } else if (val < -10) {
              val = Math.abs(val) + "-";
            }
            return val;
          },
          textAnchor: "middle",
          distributed: false,
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: "12px",
            fontFamily: "iransans",
            fontWeight: "bold",
            colors: ["#3F51B5"],
          },
          background: {
            enabled: true,
            foreColor: "#fff",
            padding: 4,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: "#fff",
            opacity: 0.9,
            dropShadow: {
              enabled: false,
              top: 1,
              left: 1,
              blur: 1,
              color: "#000",
              opacity: 0.45,
            },
          },
          dropShadow: {
            enabled: false,
            top: 1,
            left: 1,
            blur: 1,
            color: "#000",
            opacity: 0.45,
          },
        },
        stroke: {
          width: 4,
        },
        grid: {
          padding: {
            top: 0,
            right: 30,
            bottom: 0,
            left: 0,
          },
        },
      },
    };
  },
  methods: {
    GetChartReport() {
      (this.seriesLine = []),
        (this.chartOptionsLine = []),
        (this.loading = true);
      chartReport(
        this.Category,
        this.Line,
        this.Product,
        this.year,
        this.month,
        this.day
      ).then((resp) => {
        resp.data.result.yaxis.forEach((yaxis, index) => {
          this.seriesLine.push([yaxis]);
          this.chartOptionsLine.push({
            ...this.option,
            xaxis: {
              categories: resp.data.result.xaxis,
              title: {
                text: yaxis.name,
              },
            },
            yaxis: {
              title: {
                text: yaxis.typeName,
                offsetX: -20,
                offsetY: 0,
              },
              labels: {
                show: true,
                align: "right",
                minWidth: 10,
              },
            },
            chart: {
              id: "chart" + index,
              group: "social",
              type: "line",
              height: "100%",
              fontFamily: "iransans",
              dropShadow: {
                top: true,
                color: "#000",
                bottom: 55,
                left: 7,
                blur: 10,
                opacity: 0.2,
              },
              toolbar: {
                show: false,
              },
              background: "#fff",
            },
          });
        });
      });
      this.loading = false;
    },
    clickHandler(event, chartContext, config) {
      console.log(event);
      console.log(chartContext);
      console.log(config.dataPointIndex);
      console.log(this.chartOptionsLine[0].xaxis.categories[config.dataPointIndex]);
    },
  },
  watch: {
    day() {
      this.GetChartReport();
    },
    month() {
      this.GetChartReport();
    },
  },
};
</script>
